import { render } from "./AttributeListView.vue?vue&type=template&id=6ab30725"
import script from "./AttributeListView.vue?vue&type=script&lang=js"
export * from "./AttributeListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__